
import React from 'react'

interface CustomSendIMailIconProps {
  className?: string 
}


const CustomSendIMailIcon: React.FC<CustomSendIMailIconProps> = ({ className = '' }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='25' height='25' viewBox='0 0 25 25' fill='none' aria-hidden='true' className={className}>
      <path fillRule='evenodd' clipRule='evenodd' d='M21.9002 17.8986C21.8052 18.3639 21.396 18.6982 20.9212 18.6986H6.46015C6.16 18.6984 5.87584 18.5633 5.6861 18.3308C5.49636 18.0982 5.42112 17.7927 5.48115 17.4986L7.56415 7.49861C7.65913 7.03331 8.06826 6.69899 8.54315 6.69861H23.0002C23.3003 6.69885 23.5845 6.83389 23.7742 7.06646C23.9639 7.29903 24.0392 7.60453 23.9792 7.89861L21.9002 17.8986Z' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M7.92676 6.91064L13.0438 12.4216C13.7234 13.1535 14.8388 13.2717 15.6568 12.6986L23.7518 7.03264' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M1 7.69861H5' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M1 10.6986H4' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'/>
      <path d='M1 13.6986H3' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'/>
    </svg>
  )
}

export { CustomSendIMailIcon }